
import React, { useEffect, useState } from 'react';
import { Provider, useSelector } from 'react-redux';
import store from '@state/store';
import { setCookie } from '@utils/cookies';
import { RequestAQuoteModal } from './RequestAQuoteModal';
import { useLazyGetQuoteQuery, quotesApi, QUOTES_KEY_COOKIE } from './quotesApi';

interface ConnectedRequestAQuoteModalProps {
  [key: string]: any;
}

export const ConnectedRequestAQuoteModal: React.FC<ConnectedRequestAQuoteModalProps> = (props) => {
  const { dispatch } = store;
  const [isShown, setIsShown] = useState(false);
  const lastAction = useSelector((state: any) => state.lastAction);
  const [fetchQuote, { data: quote }] = useLazyGetQuoteQuery();
  const isDismissModalAction = lastAction?.type === 'modal/dismissModal';
  const isRequestAQuoteModalAction = quotesApi.endpoints.upsertItem.matchFulfilled(lastAction);

  // Show modal when upsertItem action is fulfilled
  useEffect(() => {
    if (isRequestAQuoteModalAction && !isShown) {
      const cartKey = lastAction?.payload?.cartKey;

      if (cartKey) {
        setCookie(QUOTES_KEY_COOKIE, cartKey);
        fetchQuote({ cartKey });
        setIsShown(true);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isRequestAQuoteModalAction, isShown, fetchQuote]);
  // Hide modal when dismiss action is detected
  if (isShown && isDismissModalAction) {
    setIsShown(false);
  }

  const dismissModal = () => {
    dispatch({
      type: 'modal/dismissModal'
    });
  };

  if (!isShown) {
    return null;
  }

  const variant = quote?.lines ? quote.lines[quote.lines.length - 1].variant : null;
  if(!variant) {
    return null;
  }
  return <RequestAQuoteModal variant={variant} dismissModal={dismissModal} {...props} />;
};


export const ProvideRequestAQuoteModal = (props: any) => {
  return (
    <Provider store={store}>
      <ConnectedRequestAQuoteModal {...props} />
    </Provider>
  );
};
